<template>
    <div>
        <div class="form-group breadcrumb-container">
            <div class="breadcrumb-inner">
                <b-breadcrumb class="breadcrumb p-0" :items="breadcrumbItems"></b-breadcrumb>
            </div>
        </div>
        <div class="main">
            <div class="description">
                <div class="description-inner">
                    <div class="description-text">
                        <h2>{{ $t("cookiePolicyTitle") }}</h2>
                        <p>{{ $t("cookiePolicyIntro") }}</p>
                    </div>
                </div>
            </div>
            <div class="main-part">
                <div class="page-inner">
                    <div class="big-card">
                        <div class="big-card-title">
                            <i class="fa fa-question-circle"></i>
                            <h3>{{ $t("cookiePolicyWhatTitle") }}</h3>
                        </div>
                        <p>{{ $t("cookiePolicyWhatText") }}</p>
                    </div>

                    <div class="big-card">
                        <div class="big-card-title">
                            <i class="fa fa-list"></i>
                            <h3>{{ $t("cookiePolicyWhichTitle") }}</h3>
                        </div>
                        <div class="cookie-types">
                            <div class="cookie-type">
                                <div class="cookie-type-header">
                                    <h4>{{ $t("cookieNecessaryTitle") }}</h4>
                                    <span class="cookie-type-badge">{{ $t("cookieAlwaysOn") }}</span>
                                </div>
                                <p>{{ $t("cookiePolicyNecessaryText") }}</p>
                            </div>
                            <div class="cookie-type">
                                <div class="cookie-type-header">
                                    <h4>{{ $t("cookieAnalyticsTitle") }}</h4>
                                    <span class="cookie-type-badge">{{ $t("cookieOnlyWithConsent") }}</span>
                                </div>
                                <p>{{ $t("cookiePolicyAnalyticsText") }}</p>
                                <p class="cookie-type-note">
                                    {{ $t("cookiePolicyGoogleText") }}
                                    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">policies.google.com/privacy</a>.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="big-card">
                        <div class="big-card-title">
                            <i class="fa fa-sliders"></i>
                            <h3>{{ $t("cookiePolicyManageTitle") }}</h3>
                        </div>
                        <p>{{ $t("cookiePolicyManageText") }}</p>
                        <div class="big-card-btn" role="button" tabindex="0" @click="openSettings" @keydown.enter="openSettings">
                            {{ $t("cookieSettings") }}
                        </div>
                    </div>

                    <div class="big-card">
                        <div class="big-card-title">
                            <i class="fa fa-lock"></i>
                            <h3>{{ $t("cookiePolicyPrivacyTitle") }}</h3>
                        </div>
                        <p>{{ $t("cookiePolicyPrivacyText") }}</p>
                        <a class="big-card-btn" :href="privacyPolicyUrl" :download="privacyPolicyFile" target="_blank" rel="noopener noreferrer">
                            <i class="fa fa-download mr-1"></i> {{ $t("cookiePolicyPrivacyDownload") }}
                        </a>
                    </div>

                    <div class="big-card">
                        <div class="big-card-title">
                            <i class="fa fa-envelope"></i>
                            <h3>{{ $t("cookiePolicyContactTitle") }}</h3>
                        </div>
                        <p>
                            {{ $t("cookiePolicyContactText") }}
                            <a href="mailto:info@fia.ba">info@fia.ba</a>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BBreadcrumb } from 'bootstrap-vue'
import { openCookieSettings } from "../../../cookieConsent.js"

export default {
    components: {
        bBreadcrumb: BBreadcrumb
    },
    data() {
        return {
            privacyPolicyUrl: "https://fia.ba/PublicUpload/Pravila%20privatnosti%20Finansijsko-informati%C4%8Dke%20agencije.pdf",
            privacyPolicyFile: "Pravila privatnosti Finansijsko-informatičke agencije.pdf"
        };
    },
    computed: {
        breadcrumbItems() {
            return [
                { html: "<i class='fa fa-home mr-1'></i> " + this.$t("homePage"), to: "/" },
                { text: this.$t("cookiePolicyTitle"), active: true }
            ];
        }
    },
    methods: {
        openSettings() {
            openCookieSettings();
        }
    }
}
</script>

<style scoped>
.breadcrumb-container {
    padding: 10px 7%;
    max-width: 100%;
    margin-bottom: 0px;
}

.breadcrumb-inner {
    max-width: 1440px;
    margin: 0 auto;
}

.breadcrumb {
    background-color: var(--light-color);
}

.breadcrumb >>> a {
    color: var(--main-color);
    font-weight: bold;
    font-size: clamp(1.15rem, 1.2vw, 1.1875rem);
}

.breadcrumb >>> span {
    font-size: clamp(1.15rem, 1.2vw, 1.1875rem);
}

.breadcrumb >>> a:hover {
    color: var(--main-color);
}

ol {
    margin-bottom: 0;
}

.description-text {
    width: 100%;
}

.description-text p {
    margin-top: 6px;
    width: 100%;
}

.main-part {
    padding-top: 2%;
}

.big-card {
    padding: 1.5% 2%;
}

.big-card-title h3 {
    margin-bottom: 8px;
}

.big-card p:last-child {
    margin-bottom: 0;
}

.big-card a {
    color: var(--main-color);
    text-decoration: underline;
}

.big-card-btn {
    cursor: pointer;
    margin-top: 12px;
}

a.big-card-btn {
    display: block;
    text-decoration: none;
}

a.big-card-btn:hover {
    color: #fff;
}

.cookie-types {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.cookie-type {
    background-color: #fff;
    border-radius: 10px;
    padding: 16px 20px;
}

.cookie-type-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 6px;
}

.cookie-type-header h4 {
    font-size: 22px;
    color: var(--main-color);
    margin: 0;
}

.cookie-type-badge {
    background-color: var(--secondary-color);
    color: var(--main-color);
    border-radius: 20px;
    padding: 2px 12px;
    font-size: 15px;
    line-height: 1.6;
    white-space: nowrap;
}

.cookie-type p {
    margin-bottom: 8px;
    text-align: left;
}

.cookie-type-note {
    font-size: 16px;
    line-height: 1.5;
}

@media only screen and (max-width: 768px) {
    .big-card {
        padding: 4% 5%;
    }

    .cookie-types {
        grid-template-columns: 1fr;
    }
}
</style>
